// src/utils/changeHandlers.ts
import { NavigateFunction } from "react-router-dom";
import config from "../../config";
import { ChangeData } from "./changeTypes";
import logo from "../../Assets/j.png";
import ses from "../../Assets/ses.jpg";
import { authFetch } from "../Security/authFetch";
import { getCustomerCc } from "../customerCcMap";
import { getSignatureLines } from "../emailSignature";
const email = localStorage.getItem("email");
const recipients = ["g.kattan@bcomsat.com"];

const isAdmin = localStorage.getItem("isAdmin") === "true";


export const getRecipients = async (data: ChangeData): Promise<string[]> => {
  const roleEmails = await fetchEmailsWithRole2();
  const customerEmails = getCustomerCc(data.affectedCustomer, data.affectedNetwork);
  return Array.from(new Set([...roleEmails, ...customerEmails]));
};
const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};
const fetchEmailsWithRole2 = async (): Promise<string[]> => {
  try {
    const response = await authFetch(
        `${config.apiBaseUrl}/api/responsible-person/emails/role3`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch emails");
    }
    const data = await response.json();

    const allEmails = [...data, "g.kattan@bcomsat.com"];
    const uniqueEmails = Array.from(new Set(allEmails));
    return uniqueEmails;
  } catch (err: any) {
    console.error("Email fetch failed:", err);
    return [];
  }
};
export const handleEdit = async (
    data: ChangeData,
    navigate: NavigateFunction,
    fetchMessages: () => void
) => {
  console.log("editrrrrr");
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Edited.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }
  if (data) {
    const jackson = ["jacksondoumith006@gmail.com"];
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    const mso = [
      "g.kattan@bcomsat.com",
      "w.wehbe@bcomsat.com",
      "e.moukhaiber@bcomsat.com",
      "n.vanheerden@bcomsat.com",
      "r.mdazevedo@bcomsat.com",
      "r.tuyama@bcomsat.com",
      "g.chouard@bcomsat.com",
      "j.bassante@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "v.digbeu@bcomsat.com",
      "j.sbeit@bcomsat.com",
    ];
    const emails = await getRecipients(data);
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: emails ,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - Edited`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>A ticket with ID  ${
              data.ticketId
          } has been edited with the following comment
</p> <br><br>

      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
      <p>
        <p>Regards,<br><br></p>
 <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
    </p>
    

   <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
        }),
      });
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }

  navigate(`/change-edit/${data.ticketId}`, { state: { change: data } });
};

export const handleAccept = async (
    data: ChangeData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Accepted.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    if (data) {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");
      const siteInfo =
          isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
      const linkInfo =
          isalllink === "true" ? "All Links" : data.affectedLink ?? "";
      const networkInfo =
          isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
      const mso = [
        "g.kattan@bcomsat.com",
        "w.wehbe@bcomsat.com",
        "e.moukhaiber@bcomsat.com",
        "n.vanheerden@bcomsat.com",
        "r.mdazevedo@bcomsat.com",
        "r.tuyama@bcomsat.com",
        "g.chouard@bcomsat.com",
        "j.bassante@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "v.digbeu@bcomsat.com",
        "jacksondoumith006@gmail.com",
        "j.sbeit@bcomsat.com",
      ];
      const emails = await getRecipients(data);

      try {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            to: emails,
            subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - In Progress.`,
            body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>A ticket with ID  ${
                data.ticketId
            } has been put in progress with the following comment
</p> <br><br>

      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
                data.changeStartDatetime
                    ? data.changeStartDatetime.replace("T", " ")
                    : ""
            }<br><br>


<strong>Planned close date/time:</strong> ${
                data.changeCloseDatetime
                    ? data.changeCloseDatetime.replace("T", " ")
                    : ""
            }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
      <p>
       <p>Regards,<br><br></p>
 <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
    </p>
     

<table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
          }),
        });
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }
    }
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/changes/${data.ticketId}/accept`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting change:", e);
  }
};
export const handleClose = async (
    data: ChangeData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message:
        `Change With Id ${data.ticketId} Closed.\n` +
        `Closure Code: ${data.closureCode}\n` +

        `Solution: ${data.solution}`,

    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/changes/${data.ticketId}/close`,
        {
          method: "PUT",
        }
    );

    if (updRes.ok) {
      fetchMessages();
    } else {
      console.error("Failed to close the change.");
    }
  } catch (err) {
    console.error("Error closing change:", err);
    return;
  }
  try {
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    const mso = [
      "g.kattan@bcomsat.com",
      "w.wehbe@bcomsat.com",
      "e.moukhaiber@bcomsat.com",
      "n.vanheerden@bcomsat.com",
      "r.mdazevedo@bcomsat.com",
      "r.tuyama@bcomsat.com",
      "g.chouard@bcomsat.com",
      "j.bassante@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "v.digbeu@bcomsat.com",
      "j.sbeit@bcomsat.com",
    ];
    const msgRes = await postMessage(payload);
    //console.log("Message sent:", msgRes);
  } catch (err) {
    console.error("Failed to post message:", err);
  }
  const recipients = ["g.kattan@bcomsat.com"];

  const emailBody = `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>
      <p>This Ticket with ID ${
      data.ticketId
  } was Closed with the following comment:</p><br><br>
      <p>
        <strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
       <strong>Planned start date/time:</strong> ${
      data.changeStartDatetime
          ? data.changeStartDatetime.replace("T", " ")
          : ""
  }<br><br>


<strong>Planned close date/time:</strong> ${
      data.changeCloseDatetime ? data.changeCloseDatetime.replace("T", " ") : ""
  }<br><br>
        <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
        <strong>Description:</strong> ${data.description ?? ""}<br><br>
        <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
        <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
      </p>
      <p>
       <p>Regards,<br><br></p>
    <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
    </p>
  <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `;

  try {
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    const mso = [
      "g.kattan@bcomsat.com",
      "w.wehbe@bcomsat.com",
      "e.moukhaiber@bcomsat.com",
      "n.vanheerden@bcomsat.com",
      "r.mdazevedo@bcomsat.com",
      "r.tuyama@bcomsat.com",
      "g.chouard@bcomsat.com",
      "j.bassante@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "v.digbeu@bcomsat.com",
      "j.sbeit@bcomsat.com",
    ];
    const emails = await getRecipients(data);

    if (data.ticketCreationDatetime) {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - Closed`,
          body: emailBody,
        }),
      });
      //console.log("Customer informed email sent.");
    } else if (!isAdmin) {
      const emails = await getRecipients(data);
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - Closed`,
          body: emailBody,
        }),
      });
      //console.log("Fallback email sent to role 2 users.");
    }
    window.location.reload();
  } catch (e) {
    console.error("Error sending email:", e);
  }
};


export const handlePause = async (
    data: ChangeData,
    fetchMessages: () => void
) => {
  const comment = localStorage.getItem("comment") || "System";

  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Paused.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/changes/${data.ticketId}/pause`,
        {
          method: "PUT",
        }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Pause or save message");
    }
  } catch (e) {
    console.error("Error while Pausing change:", e);
  }
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const siteInfo = isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
  const linkInfo = isalllink === "true" ? "All Links" : data.affectedLink ?? "";
  const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
  const mso = [
    "g.kattan@bcomsat.com",
    "w.wehbe@bcomsat.com",
    "e.moukhaiber@bcomsat.com",
    "n.vanheerden@bcomsat.com",
    "r.mdazevedo@bcomsat.com",
    "r.tuyama@bcomsat.com",
    "g.chouard@bcomsat.com",
    "j.bassante@bcomsat.com",
    "c.nakhle@bcomsat.com",
    "v.digbeu@bcomsat.com",
    "j.sbeit@bcomsat.com",
  ];
  const emails = await getRecipients(data);

  if (data.ticketCreationDatetime) {
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - On Hold`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>A ticket with ID ${
              data.ticketId
          } has been put on hold with the following comment
</p><br><br>

      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p><br><br>
      <strong>Comment:</strong> ${comment ?? ""}</p>
      <p>
          <p>Regards,<br><br></p>
      <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
      </p>
  

      <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  } else if (!isAdmin) {
    try {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");
      const siteInfo =
          isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
      const linkInfo =
          isalllink === "true" ? "All Links" : data.affectedLink ?? "";
      const networkInfo =
          isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
      const mso = [
        "g.kattan@bcomsat.com",
        "w.wehbe@bcomsat.com",
        "e.moukhaiber@bcomsat.com",
        "n.vanheerden@bcomsat.com",
        "r.mdazevedo@bcomsat.com",
        "r.tuyama@bcomsat.com",
        "g.chouard@bcomsat.com",
        "j.bassante@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "v.digbeu@bcomsat.com",
        "j.sbeit@bcomsat.com",
      ];
      const emails = await getRecipients(data);
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - On Hold `,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>A ticket with ID ${
              data.ticketId
          } has been put on hold with the following comment</p><br><br>
                 <p><strong>Customer:</strong> ${
              data.affectedCustomer ?? ""
          }<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
            <p>
               <p>Regards,<br><br><br></p>
          <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
            </p>
         
          <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
      //console.log("Email sent: Customer was NOT informed.");
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }
  }
};

export const handleReactivate = async (
    data: ChangeData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Reactivated.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/changes/${data.ticketId}/reactivate`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating change:", e);
  }
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const siteInfo = isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
  const linkInfo = isalllink === "true" ? "All Links" : data.affectedLink ?? "";
  const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
  const mso = [
    "g.kattan@bcomsat.com",
    "w.wehbe@bcomsat.com",
    "e.moukhaiber@bcomsat.com",
    "n.vanheerden@bcomsat.com",
    "r.mdazevedo@bcomsat.com",
    "r.tuyama@bcomsat.com",
    "g.chouard@bcomsat.com",
    "j.bassante@bcomsat.com",
    "c.nakhle@bcomsat.com",
    "v.digbeu@bcomsat.com",
    "j.sbeit@bcomsat.com",
  ];
  const emails = await getRecipients(data);

  if (data.ticketCreationDatetime) {
    //console.log("emaaaaaaiiiiiiiiiiilllllllllllllll", email);
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | -  Reactivated.`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

   A ticket with ID ${
              data.ticketId
          }  has been reactivated with the following comment <br><br>


      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>
  <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
  <strong>Description:</strong> ${data.description ?? ""}<br><br>
  <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
  <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
    <p>
    <p>Regards,<br><br></p>
 <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
    </p>
      

     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  } else if (!isAdmin) {
    try {
      const emails = await getRecipients(data);
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - Reactivated`,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>   A ticket with ID ${
              data.ticketId
          }  has been reactivated with the following comment
</p><br><br>
                <p><strong>Customer:</strong> ${
              data.affectedCustomer ?? ""
          }<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p><br>
            <p>
               <p>Regards,<br><br><br></p>
          <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
            </p>
         
           <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
      //console.log("Email sent: Customer was NOT informed.");
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }
  }
};

export const handleReopen = async (
    data: ChangeData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/changes/${data.ticketId}/reopen`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating change:", e);
  }
  if (data.ticketCreationDatetime) {
    try {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");
      const siteInfo =
          isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
      const linkInfo =
          isalllink === "true" ? "All Links" : data.affectedLink ?? "";
      const networkInfo =
          isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
      const mso = [
        "g.kattan@bcomsat.com",
        "w.wehbe@bcomsat.com",
        "e.moukhaiber@bcomsat.com",
        "n.vanheerden@bcomsat.com",
        "r.mdazevedo@bcomsat.com",
        "r.tuyama@bcomsat.com",
        "g.chouard@bcomsat.com",
        "j.bassante@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "j.sbeit@bcomsat.com",
        "v.digbeu@bcomsat.com",
      ];
      const emails = await getRecipients(data);

      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to:emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - Reopened`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>This Ticket with ID ${
              data.ticketId
          } was Reopened with following comment:</p><br><br>

      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
      <p>
        <p>Regards,<br><br><br></p>
     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
      </p>
    

    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
        }),
      });
      // alert(recipients);
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  } else if (!isAdmin) {
    try {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");
      const siteInfo =
          isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
      const linkInfo =
          isalllink === "true" ? "All Links" : data.affectedLink ?? "";
      const networkInfo =
          isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
      const mso = [
        "g.kattan@bcomsat.com",
        "w.wehbe@bcomsat.com",
        "e.moukhaiber@bcomsat.com",
        "n.vanheerden@bcomsat.com",
        "r.mdazevedo@bcomsat.com",
        "r.tuyama@bcomsat.com",
        "g.chouard@bcomsat.com",
        "j.bassante@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "v.digbeu@bcomsat.com",
        "j.sbeit@bcomsat.com",
      ];
      const emails = await getRecipients(data);
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `Change ID ${data.ticketId} | ${data.affectedCustomer} | - Reopened`,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
           <p>A Ticket with ID ${
              data.ticketId
          } was Reopened with following comment:</p>
                 <p><strong>Customer:</strong> ${
              data.affectedCustomer ?? ""
          }<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Planned start date/time:</strong> ${
              data.changeStartDatetime
                  ? data.changeStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Planned close date/time:</strong> ${
              data.changeCloseDatetime
                  ? data.changeCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
            <p>
               <p>Regards,<br><br><br><br></p>
           <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
            </p>
         
          <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">
           <td style="vertical-align: top; padding-right: 12px;">
         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
        </td>

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
      //console.log("Email sent: Customer was NOT informed.");
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }
  }
};
